var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pageTop" },
    [
      _c("LoginPageTitle", { attrs: { "title-text": "ログイン" } }),
      _vm._v(" "),
      _c("TextLink", {
        staticClass: "newRegistration",
        attrs: {
          "arrow-type": "rightArrowRight",
          "link-url": "/smp2/quipMember/register/infoInput/",
          "link-text": "新規会員登録",
        },
        on: {
          onClick: function ($event) {
            return _vm.onClick($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }